import { useEffect, useState, useCallback } from "react";
import { getAccountsUser } from "../services/modulesApi";
import { savePrefs, errMsg } from "../services/accountApi";

// 2026-10-26 (owner): "Style profit search" on/off is PER PERSON. Stored on the user (users.prefs.style_profit_search, default ON) so it
// follows the person across devices; the signed-in user object (/api/account/me -> user.prefs) is the single read source.
const listeners = new Set();
const isOn = () => {
  const u = getAccountsUser();
  return !(u && u.prefs && u.prefs.style_profit_search === false);
};

export function useStyleProfitPref(showToast) {
  const [on, setOn] = useState(isOn);
  useEffect(() => {
    const fn = () => setOn(isOn());
    listeners.add(fn); fn();
    return () => { listeners.delete(fn); };
  }, []);
  const set = useCallback(async (next) => {
    const u = getAccountsUser();
    if (!u) return;
    const prev = isOn();
    u.prefs = { ...(u.prefs || {}), style_profit_search: next };
    listeners.forEach((f) => f());
    try {
      const r = await savePrefs({ style_profit_search: next });
      u.prefs = { ...(u.prefs || {}), ...(r.prefs || {}) };
      listeners.forEach((f) => f());
      if (showToast) showToast(next ? "Style profit search turned on" : "Style profit search hidden - turn it back on from your account menu", "success");
    } catch (e) {
      console.error("[prefs] style_profit_search not saved", e);
      u.prefs = { ...(u.prefs || {}), style_profit_search: prev };
      listeners.forEach((f) => f());
      if (showToast) showToast(errMsg(e, "Could not save your preference"), "error");
    }
  }, [showToast]);
  return [on, set];
}

// 2026-10-26 (owner decision 2026-10-24: not admin-only): any signed-in person who holds at least one tool sees the Style profit
// section (sidebar + Overall Summary) unless they switched it off for themselves. Department limits are enforced by the server.
export const showStyleProfitFor = (user, on) => !!user && on !== false && Array.isArray(user.tools) && user.tools.length > 0;
